/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_Error_SaveInputs */



/**
* | output |
* | --- |
* | "Failed to save the promo report" |
*
* @param {Promos_Error_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_error_save = /** @type {((inputs?: Promos_Error_SaveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Error_SaveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer le rapport de promos")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo guardar el informe de promos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível salvar o relatório de promos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare il rapporto promo")
	return /** @type {LocalizedString} */ ("Failed to save the promo report")
});